import React, { useEffect, useState } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { useContentWorkflowFieldsValidation } from 'form-templates/hooks/useContentWorkflow';
import { ActSubmit } from 'components/common/form/act';
import useBundleTranslation from 'i18n';
import LoadingPlaceholder from 'components/common/loading-placeholder/LoadingPlaceholder';
import { Typography } from '@mui/material';

export default function ExtReport(props: IFormLayoutProps) {
    const { t } = useBundleTranslation('app/editor/element/extreport');
    const { workflowFieldsValidation } = useContentWorkflowFieldsValidation(props.hookForm.form, t);

    props.hookForm.form.formAct.overrideAct(
        'submit',
        class extends ActSubmit {
            async exec(data: any): Promise<any> {
                const workflowValidation = await workflowFieldsValidation();
                if (!workflowValidation) {
                    return Promise.resolve({ data: { status: 'CANCELED' } });
                }
                return super.exec(data);
            }
        },
    );

    const list = props.hookForm.form.hookFormWatch([
        'external_report_external_id',
        'external_report_auto_update_image_ind',
        'external_report_on_demand_collection_ind',
        'external_report_trusted_collection_ind',
    ]);
    const [isLoading, setIsLoading] = useState(true);
    const timerRef = React.useRef(0);
    useEffect(() => {
        if (!props.hookForm.form.formDidMount) {
            return;
        }
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = window.setTimeout(() => setIsLoading(false), 1000);
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [list, props.hookForm.form.formDidMount]);

    return (
        <>
            {isLoading && (
                <LoadingPlaceholder>
                    <Typography>{t('loading___')}</Typography>
                </LoadingPlaceholder>
            )}
            <FormLayoutComposer props={props} />
        </>
    );
}
